import { ArrayInput, AutocompleteInput, ReferenceInput, required, SelectInput, SimpleFormIterator, TextInput } from "react-admin";
import { useWatch } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { SemestersChoices } from "utils/choices";
import OptionsIteratorItem from "./Partials/OptionsIteratorItem";

const SaveForm = () => {
  const specialityId = useWatch({ name: "specialityId" });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="name"
          label="Име на кампанията"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
        >
          <AutocompleteInput
            label="Специалност"
            optionText="name"
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <SelectInput
          source="semester"
          label="Семестър"
          choices={SemestersChoices}
          validate={required()}
          fullWidth
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <CustomDateInput
          source="applicationStartDate"
          label="Начало на кандидатстването"
          validate={required()}
          required
          noTime
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <CustomDateInput
          source="applicationEndDate"
          label="Край на кандидатстването"
          validate={required()}
          required
          noTime
        />
      </Grid>

      {specialityId && (
        <Grid
          item
          xs={12}
        >
          <Typography
            color="primary"
            sx={{ marginTop: 2 }}
          >
            Учебни планове за избор
          </Typography>
          <ArrayInput
            source="options"
            label={false}
            defaultValue={[{}]}
          >
            <SimpleFormIterator
              inline={false}
              sx={settings.style.iteratorWithoutGap}
            >
              <OptionsIteratorItem />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      )}
    </Grid>
  );
};

export default SaveForm;
